type SessionStore = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
const HANDOFF = 'talisman-update-reload';

/** An automatic update is a continuation, not another two-second welcome. */
export function consumeUpdateReload(storage: () => SessionStore, navigationType: string, now = Date.now()): boolean {
  try {
    const saved = storage().getItem(HANDOFF);
    storage().removeItem(HANDOFF);
    const age = now - Number(saved);
    return saved !== null && navigationType === 'reload' && age >= 0 && age < 60_000;
  } catch { return false; }
}

/** Service-worker activation and stale-chunk recovery can race in one page. */
export function createUpdateReload(storage: () => SessionStore, reload: () => void, now = Date.now) {
  let reloading = false;
  return () => {
    if (reloading) return;
    reloading = true;
    try { storage().setItem(HANDOFF, String(now())); } catch { /* Updates still work without session storage. */ }
    reload();
  };
}

/** Never paint a fallback and then swap the splash lettering. A failed/slow
 * font load chooses system faces for this splash, without blocking sign-in. */
export async function waitForBrandFonts(fonts?: Pick<FontFaceSet, 'load'>, timeoutMs = 1500): Promise<boolean> {
  if (!fonts) return false;
  let timer: ReturnType<typeof setTimeout>;
  try {
    return await Promise.race([
      Promise.all([
        fonts.load('600 30px "Cormorant Garamond"', 'Talisman'),
        fonts.load('400 16px "Instrument Sans"', 'Every traveller’s lucky charm'),
      ]).then(faces => faces.every(result => result.length > 0)),
      new Promise<boolean>(resolve => { timer = setTimeout(() => resolve(false), timeoutMs); }),
    ]);
  } catch { return false; }
  finally { clearTimeout(timer!); }
}
